module.exports = __webpack_public_path__ + "img/green-1-oval-open.fba19eaa.svg";